<script setup>
  defineProps({
    errors: {
      type: Array,
      default: () => [],
    },
  })
</script>

<template>
  <span class="validation-errors"><slot /></span>

  <span v-for="error of errors" :key="error.$uid" class="validation-errors">{{
    error.$message
  }}</span>
</template>

<style lang="scss" scoped>
  .validation-errors {
    color: var(--fm-ui-red-color);
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    &:empty {
      display: none;
    }
  }
</style>
